<!--<div class="navbar-top" [ngClass]="fuseConfig?.layout?">-->

<!--    <div class="logo">-->
<!--&lt;!&ndash;        <img class="logo-icon" src="../../../../../../assets/images/logos/fuse.svg" alt="Tpl Rad">&ndash;&gt;-->
<!--        <span class="logo-text secondary-text">FUSE</span>-->
<!--    </div>-->

<div class="sidebar-scroll">
  <div class="buttons pl-12 pr-20 pt-12 pb-4">

    <button mat-icon-button class="toggle-sidebar-folded"
            (click)="toggleSidebarFolded()" fxHide.lt-lg>
      <mat-icon class="secondary-text">menu</mat-icon>
    </button>

    <button mat-icon-button class="toggle-sidebar-opened"
            (click)="toggleSidebarOpened()" fxHide.gt-md>
      <img src="assets/img/icons/arrow-left.svg" alt="Arrow Left">
    </button>
  </div>
  <ksm-sidebar></ksm-sidebar>
</div>


<!--</div>-->

<!--<div class="navbar-scroll-container" [ngClass]="fuseConfig?.layout?.navbar.primaryBackground"-->
<!--     fusePerfectScrollbar [fusePerfectScrollbarOptions]="{suppressScrollX: true}">-->

<!--    <div class="user" fxLayout="column" [ngClass]="fuseConfig?.layout?.navbar.secondaryBackground">-->

<!--        <div class="h3 username">{{authService.userDetails?.login}}</div>-->
<!--        <div class="h5 email hint-text mt-8">{{authService.userDetails?.email}}</div>-->
<!--&lt;!&ndash;            <div class="avatar-container" [ngClass]="fuseConfig?.layout?.navbar.primaryBackground">&ndash;&gt;-->
<!--&lt;!&ndash;                <img class="avatar" src="../../assets/images/avatars/Velazquez.jpg" alt="Velazquez">&ndash;&gt;-->
<!--&lt;!&ndash;            </div>&ndash;&gt;-->

<!--    </div>-->

<!--&lt;!&ndash;    <div class="navbar-content">&ndash;&gt;-->
<!--&lt;!&ndash;        <fuse-navigation class="material2" layout="vertical"></fuse-navigation>&ndash;&gt;-->
<!--&lt;!&ndash;    </div>&ndash;&gt;-->

<!--</div>-->


